import React, { useMemo } from "react";

import type {
    ColDef,
    CustomCellRendererProps,
    GridOptions,
} from "@/ui/molecules/Grid";
import Grid from "@/ui/molecules/Grid";

export type DealActivityListProps = {
    activityList: DealActivity[];
    ComponentFormattedDate?: React.ComponentType<{ date: string }>;
};

export type DealActivity = {
    user: string;
    action: string;
    timestamp: string;
};

const DealActivityList = ({
    activityList,
    ComponentFormattedDate = (props: { date: string }) => {
        return props.date;
    },
}: DealActivityListProps) => {
    const DateCellRenderer = React.useMemo(
        // eslint-disable-next-line react/no-unstable-nested-components, react/display-name
        () => (props: CustomCellRendererProps<DealActivity, string>) => {
            return (
                props.value !== null &&
                props.value !== undefined && (
                    <ComponentFormattedDate date={props.value} />
                )
            );
        },
        [ComponentFormattedDate],
    );

    const columnDefs = useMemo<ColDef<DealActivity>[]>(
        () => [
            {
                headerName: "Action",
                field: "action",
                flex: 1,
            },
            { headerName: "Action By", field: "user" },
            {
                headerName: "Date",
                field: "timestamp",
                cellRenderer: DateCellRenderer,
            },
        ],
        [DateCellRenderer],
    );

    const defaultColDef = useMemo<ColDef>(
        () => ({
            minWidth: 200,
            sortable: true,
            filter: true,
            resizable: true,
        }),
        [],
    );

    const gridOptions = useMemo(
        () =>
            ({
                autoSizeStrategy: {
                    type: "fitGridWidth",
                },
                columnMenu: "legacy",
            }) as GridOptions<DealActivity>,
        [],
    );

    return (
        <Grid<DealActivity>
            gridTheme={"ag-theme-custom-proda"}
            gridOptions={gridOptions}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            suppressHeaderFocus={true}
            suppressCellFocus={true}
            rowData={activityList}
            enterNavigatesVertically={true}
            enterNavigatesVerticallyAfterEdit={true}
        />
    );
};

export default DealActivityList;
